// src/components/dashboard/LoadingSkeleton.tsx
import React, { memo } from "react";

interface LoadingSkeletonProps {
  count?: number;
}

export const LoadingSkeleton = memo(({ count = 5 }: LoadingSkeletonProps) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
    {Array.from({ length: count }).map((_, i) => (
      <div
        key={i}
        className="aspect-[3/4] bg-white/5 rounded-[32px] animate-pulse"
      />
    ))}
  </div>
));

LoadingSkeleton.displayName = "LoadingSkeleton";
